export default "/images/forsia.png?90abdbbc9722301c9f0f8884d59e6e78";